import { Box, Grid, Paper, Typography } from '@material-ui/core'

import React, { FC } from 'react'
import styled from 'styled-components'

import InLineBox from '../components/inLineBox'

const StyledPaper = styled(Paper)`
  width: 100%;
`
const Title = styled(Box)`
  height: 30px;
  margin: 20px;
  font-weight: 700;
`

const InLineContainer = styled.div`
  height: 30px;
  margin: 20px 0px 10px 0px;
`

const ListTitleBar: FC<any> = ({
  title,
  statistics
}: {
  title: string
  statistics: { [key: string]: number } | null
}) => (
  <Grid container style={{ width: '100%' }} alignItems="stretch">
    <StyledPaper>
      <Grid item xs={12}>
        <Typography component="h2" variant="h5">
          <Title>{title}</Title>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <InLineContainer>
          {statistics && <InLineBox items={statistics} fontSize={14} />}
        </InLineContainer>
      </Grid>
    </StyledPaper>
  </Grid>
)

export default ListTitleBar
